import { render, staticRenderFns } from "./CompanyEditModuleMetaDataExtraUsers.vue?vue&type=template&id=a6a4d670&"
import script from "./CompanyEditModuleMetaDataExtraUsers.vue?vue&type=script&lang=ts&"
export * from "./CompanyEditModuleMetaDataExtraUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a4d670')) {
      api.createRecord('a6a4d670', component.options)
    } else {
      api.reload('a6a4d670', component.options)
    }
    module.hot.accept("./CompanyEditModuleMetaDataExtraUsers.vue?vue&type=template&id=a6a4d670&", function () {
      api.rerender('a6a4d670', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company/CompanyEditModuleMetaDataExtraUsers.vue"
export default component.exports